import { getLoginPage } from "../../../config/loginContent.js";

function escapeAttr(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;");
}

function renderField(field) {
  const minlength = field.minlength ? ` minlength="${field.minlength}"` : "";
  const autocomplete = field.autocomplete
    ? ` autocomplete="${escapeAttr(field.autocomplete)}"`
    : "";

  return `
    <label class="login-form__field contact__field">
      <span class="sr-only">${field.placeholder}</span>
      <input
        type="${field.type}"
        name="${field.name}"
        placeholder="${escapeAttr(field.placeholder)}"
        ${field.required ? "required" : ""}
        ${minlength}
        ${autocomplete}
        data-login-field
      />
    </label>
  `;
}

function renderSuccess(success) {
  return `
    <div class="login-form__success" role="status">
      <p class="login-form__success-kicker">Signed in</p>
      <h3 class="login-form__success-title">${success.title}</h3>
      <p class="login-form__success-body">${success.body}</p>
      <div class="login-form__success-actions">
        <a class="btn btn--primary" href="${success.primaryHref}">${success.primaryLabel}</a>
        <a class="btn btn--ghost" href="${success.secondaryHref}">${success.secondaryLabel}</a>
      </div>
    </div>
  `;
}

export function createLoginFormSection() {
  const page = getLoginPage();
  const { form, success } = page;

  const section = document.createElement("section");
  section.id = "login";
  section.className = "section login-form-section";

  section.innerHTML = `
    <div class="section__inner login-form-section__inner reveal">
      <div class="login-form__panel" data-login-panel>
        <div class="login-form__intro">
          <p class="login-form__eyebrow">${form.eyebrow}</p>
          <h2 class="login-form__heading">${form.heading}</h2>
        </div>
        <form class="login-form contact__form" novalidate data-login-form>
          <div class="login-form__fields">
            ${form.fields.map(renderField).join("")}
          </div>
          <p class="login-form__error" data-login-error hidden></p>
          <button class="btn btn--primary contact__submit" type="submit">${form.submitLabel}</button>
        </form>
        <p class="login-form__switch">
          ${form.registerPrompt}
          <a href="${form.registerHref}">${form.registerLabel}</a>
        </p>
      </div>
    </div>
  `;

  bindLoginForm(section, success);
  return section;
}

function bindLoginForm(section, success) {
  const panel = section.querySelector("[data-login-panel]");
  const formEl = section.querySelector("[data-login-form]");
  const errorEl = section.querySelector("[data-login-error]");

  formEl.addEventListener("submit", (event) => {
    event.preventDefault();
    errorEl.hidden = true;
    errorEl.textContent = "";

    if (!formEl.checkValidity()) {
      formEl.reportValidity();
      return;
    }

    const data = new FormData(formEl);
    const email = String(data.get("email") || "").trim();
    const password = String(data.get("password") || "");

    if (!email) {
      errorEl.hidden = false;
      errorEl.textContent = "Enter your work email.";
      formEl.querySelector('[name="email"]')?.focus();
      return;
    }

    if (password.length < 8) {
      errorEl.hidden = false;
      errorEl.textContent = "Password must be at least 8 characters.";
      formEl.querySelector('[name="password"]')?.focus();
      return;
    }

    panel.innerHTML = renderSuccess(success);
  });
}
